// ------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------

import { Dictionary } from '../../../shared/models/dictionary.model';
import { IBaseType } from '../../../shared/enums/ibase-type.enum';

export interface IDriverCredentialApplicationItemSourceType {
    id: number;
    value: string;
    displayValue: string;
    description: string;
    sortOrder: number;
    active: boolean;
}

export class DriverCredentialApplicationItemSourceType implements IDriverCredentialApplicationItemSourceType, IBaseType {
    public id: number;
    public value: string;
    public displayValue: string;
    public description: string;
    public sortOrder: number;
    public active: boolean;

    /**
		Returns CSR DriverCredentialApplicationItemSourceType
	**/
    get CSR(): IDriverCredentialApplicationItemSourceType {
        return this.FromId(1);
    }
    /**
		Returns Non - CMV skills DriverCredentialApplicationItemSourceType
	**/
    get NonCMVskills(): IDriverCredentialApplicationItemSourceType {
        return this.FromId(2);
    }
    /**
		Returns CMV skills DriverCredentialApplicationItemSourceType
	**/
    get CMVskills(): IDriverCredentialApplicationItemSourceType {
        return this.FromId(3);
    }
    /**
		Returns Medical Review DriverCredentialApplicationItemSourceType
	**/
    get MedicalReview(): IDriverCredentialApplicationItemSourceType {
        return this.FromId(4);
    }
    /**
		Returns Application Request DriverCredentialApplicationItemSourceType
	**/
    get ApplicationRequest(): IDriverCredentialApplicationItemSourceType {
        return this.FromId(5);
    }
    /**
		Returns Med Cert DriverCredentialApplicationItemSourceType
	**/
    get MedCert(): IDriverCredentialApplicationItemSourceType {
        return this.FromId(6);
    }
    /**
		Returns Vision Screening/Report DriverCredentialApplicationItemSourceType
	**/
    get VisionScreeningReport(): IDriverCredentialApplicationItemSourceType {
        return this.FromId(7);
    }
    /**
		Returns LECU DriverCredentialApplicationItemSourceType
	**/
    get LECU(): IDriverCredentialApplicationItemSourceType {
        return this.FromId(8);
    }
    /**
		Returns Medical Exam Certificate DriverCredentialApplicationItemSourceType
	**/
    get MEC(): IDriverCredentialApplicationItemSourceType {
        return this.FromId(9);
    }
    /**
		Returns Manual DriverCredentialApplicationItemSourceType
	**/
    get Manual(): IDriverCredentialApplicationItemSourceType {
        return this.FromId(10);
    }
    /**
		Returns Motorcycle Skills DriverCredentialApplicationItemSourceType
	**/
    get MotorcycleSkills(): IDriverCredentialApplicationItemSourceType {
        return this.FromId(11);
    }
    /**
		Returns Residency Type DriverCredentialApplicationItemSourceType
	**/
    get ResidencyType(): IDriverCredentialApplicationItemSourceType {
        return this.FromId(12);
    }
    /**
		Returns Medical Exam Report DriverCredentialApplicationItemSourceType
	**/
    get MedicalExamReport(): IDriverCredentialApplicationItemSourceType {
        return this.FromId(13);
    }
    /**
		Returns Conversion DriverCredentialApplicationItemSourceType
	**/
    get Conversion(): IDriverCredentialApplicationItemSourceType {
        return this.FromId(14);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('1', { id: 1, value: 'CSR', displayValue: 'CSR', description: 'CSR', sortOrder: 999999, active: true });
        this._dictionary.add('2', { id: 2, value: 'NonCMVskills', displayValue: 'Non - CMV skills', description: 'Non - CMV skills', sortOrder: 999999, active: true });
        this._dictionary.add('3', { id: 3, value: 'CMVskills', displayValue: 'CMV skills', description: 'CMV skills', sortOrder: 999999, active: true });
        this._dictionary.add('4', { id: 4, value: 'MedicalReview', displayValue: 'Medical Review', description: 'Medical Review', sortOrder: 999999, active: true });
        this._dictionary.add('5', { id: 5, value: 'ApplicationRequest', displayValue: 'Application Request', description: 'Application Request', sortOrder: 999999, active: true });
        this._dictionary.add('6', { id: 6, value: 'MedCert', displayValue: 'Med Cert', description: 'Med Cert', sortOrder: 999999, active: true });
        this._dictionary.add('7', { id: 7, value: 'VisionScreeningReport', displayValue: 'Vision Screening/Report', description: 'Vision Screening/Report', sortOrder: 999999, active: true });
        this._dictionary.add('8', { id: 8, value: 'LECU', displayValue: 'LECU', description: 'LECU', sortOrder: 999999, active: true });
        this._dictionary.add('9', { id: 9, value: 'MEC', displayValue: 'Medical Exam Certificate', description: 'Commercial Medical Exam', sortOrder: 999999, active: true });
        this._dictionary.add('10', { id: 10, value: 'Manual', displayValue: 'Manual', description: 'Manual', sortOrder: 999999, active: true });
        this._dictionary.add('11', { id: 11, value: 'MotorcycleSkills', displayValue: 'Motorcycle Skills', description: 'Motorcycle Skills', sortOrder: 999999, active: true });
        this._dictionary.add('12', { id: 12, value: 'ResidencyType', displayValue: 'Residency Type', description: 'Residency Type', sortOrder: 999999, active: true });
        this._dictionary.add('13', { id: 13, value: 'MedicalExamReport', displayValue: 'Medical Exam Report', description: 'Non-Commercial Medical Exam', sortOrder: 999999, active: true });
        this._dictionary.add('14', { id: 14, value: 'Conversion', displayValue: 'Conversion', description: 'Conversion', sortOrder: 999999, active: true });
    }

    public ToString(): string {
        return this.displayValue == null ? null : this.displayValue.toString();
    }

    public FromId(id: number): IDriverCredentialApplicationItemSourceType {
        return this._dictionary[id];
    }

    public FromValue(value: string): IDriverCredentialApplicationItemSourceType {
        var match = this._dictionary.getValues().filter(d => d.value == value);

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): IDriverCredentialApplicationItemSourceType[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): IDriverCredentialApplicationItemSourceType[] {
        return this.GetAll().filter(d => d.active);
    }

    public Sort(primaryField, secondaryField, reverse): IDriverCredentialApplicationItemSourceType[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = (path, reverse, primer, then) => {
        var get = (obj, path) => {
                if (path) {
                    path = path.split('.');

                    for (var i = 0, len = path.length - 1; i < len; i++) {
                        obj = obj[path[i]];
                    }

                    return obj[path[len]];
                }
                return obj;
            },
            prime = (obj) => primer ? primer(get(obj, path)) : get(obj, path);

        return (a, b) => {
            var A = prime(a),
                B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
